import { lazy } from 'react';

const Audit = lazy(() =>
  import('@/screens/Audit').then((module) => ({ default: module.Audit })),
);
const Tickets = lazy(() =>
  import('@/screens/Tickets').then((module) => ({ default: module.TicketDashboard })),
);
const AreaBumpChart = lazy(() => import('./AreaBumpChart'));
const BarChart = lazy(() => import('./BarChart'));
const BarLineChart = lazy(() => import('./BarLineChart'));
const BigCalendar = lazy(() => import('./BigCalendar'));
const DefaultCard = lazy(() => import('./DefaultCard'));
const DonutChart = lazy(() => import('./DonutChart'));
const FilterCard = lazy(() => import('./FilterCard'));
const FrameCard = lazy(() => import('./FrameCard'));
const GaugeChart = lazy(() => import('./GaugeChart'));
const GaugeChartV2 = lazy(() => import('./GaugeChartV2'));
const GoogleMap = lazy(() => import('./GoogleMap'));
const GoogleMapV2 = lazy(() => import('./GoogleMapV2'));
const Header = lazy(() => import('./Header'));
const HeatmapChart = lazy(() => import('./HeatmapChart'));
const LineChart = lazy(() => import('./LineChart'));
const List = lazy(() => import('./List'));
const Map = lazy(() => import('./Map'));
const MultiCardComponent = lazy(() => import('./MultiCard'));
const MultipleDonutsChart = lazy(() => import('./MultiDonutsCharts'));
const PhotoBook = lazy(() => import('./PhotoBook'));
const ProgressBar = lazy(() => import('./ProgressBar'));
const PyramidChart = lazy(() => import('./PyramidCharts'));
const RadarChart = lazy(() => import('./RadarChart'));
const ResponsiveList = lazy(() => import('./ResponsiveList'));
const ResponsiveTable = lazy(() =>
  import('./ResponsiveTable').then((module) => ({
    default: module.ResponsiveTableCard,
  })),
);
const ResponsiveTableMulti = lazy(() => import('./ResponsiveTableMulti'));
const ResponsiveTableText = lazy(() => import('./ResponsiveTableText'));
const SimpleText = lazy(() => import('./SimpleText'));
const Table = lazy(() => import('./Table'));
const Tabs = lazy(() => import('./Tabs'));

export default {
  DefaultCard,
  ResponsiveTable,
  ResponsiveTableText,
  Table,
  ResponsiveList,
  List,
  DonutChart,
  BarChart,
  LineChart,
  BarLineChart,
  RadarChart,
  HeatmapChart,
  GaugeChart,
  GaugeChartV2,
  SimpleText,
  ResponsiveTableMulti,
  PhotoBook,
  Map,
  Header,
  Tabs,
  FilterCard,
  FrameCard,
  MultipleDonutsChart,
  PyramidChart,
  BigCalendar,
  GoogleMap,
  GoogleMapV2,
  AreaBumpChart,
  Audit,
  Tickets,
  ProgressBar,
  MultiCardComponent,
};
